import { nameof } from 'ts-simple-nameof'
import * as yup from 'yup'
import { customNullable } from '.'
import type { AppInfoMessage } from '../dtos'

export const AppInfoMessageValidationRuleObject = {
    [nameof<AppInfoMessage>(x => x.insuranceCategoryType)]: customNullable(yup.number().required('Vyberte aplikaci')),
    [nameof<AppInfoMessage>(x => x.messageDate)]: yup.date().required('Zadejte datum')
}

export const AppInfoMessageValidationSchema = yup.object().shape(AppInfoMessageValidationRuleObject) as any